import { useMemo } from "react";
import { Button } from 'antd';
import { useIsMobileDevice } from "hooks";
import { useTranslation } from "react-i18next"
import UnberryModal from "../UnberryModal";
import Carousel, { CarouselItem } from "../Carousel";
import './style.scss';
import CameraPermissionTabImageTwo from '../../../assets/img/permission/cam-permission-tab-image-2.png';
import CameraPermissionTabImageThird from '../../../assets/img/permission/cam-permission-tab-image-3.png';
import CameraPermissionCarouselOne from '../../../assets/img/permission/cam-permission-carousel-1.png';
import CameraPermissionCarouselTwo from '../../../assets/img/permission/cam-permission-carousel-2.png';
import CameraPermissionCarouselThree from '../../../assets/img/permission/cam-permission-carousel-3.png';
import CamMicPermissionTabImageOne from '../../../assets/img/permission/cam-mic-permission-tab-image-1.png';
import CamMicPermissionTabImageTwo from '../../../assets/img/permission/cam-mic-permission-tab-image-2.png';
import CamMicPermissionTabImageThird from '../../../assets/img/permission/cam-mic-permission-tab-image-3.png';
import CamMicPermissionCarouselOne from '../../../assets/img/permission/cam-mic-permission-carousel-1.jpg';
import CamMicPermissionCarouselTwo from '../../../assets/img/permission/cam-mic-permission-carousel-2.jpg';
import CamMicPermissionCarouselThree from '../../../assets/img/permission/cam-mic-permission-carousel-3.jpg';
import IOSCamMicPermissionCarouselThree from '../../../assets/img/permission/ios-cam-mic-permission-carousel-3.jpg';
import AndroidCamPermissionCarouselThree from '../../../assets/img/permission/android-cam-permission-carousel-3.jpg';

import { PERMISSION_DEVICE_TYPES, PERMISSION_ERRORS } from "constants/globalConstants";

const { NO_DEVICE, NO_INTERNET, VIDEO_SOURCE, PERMISSION_DENIED, PERMISSION_DENIED_BY_SYSTEM, CAMERA_FEED,
  API_FAILURE, SCREEN_PERMISSION_DENIED, STOP_SHARING, ENTIRE_SCREEN, USER_GESTURE, API_BLOCK
} = PERMISSION_ERRORS;

const isUserAgentIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent)

const cameraTabData = (t) => ([
  {
    tabText: "camTab.step1.tab",
    imgSrc: CamMicPermissionTabImageOne,
    carouselText: isUserAgentIOS()
      ? "camTab.step1.carousel_ios"
      : "camTab.step1.carousel_others",
    carouselImgSrc: isUserAgentIOS()
      ? CameraPermissionCarouselOne
      : CamMicPermissionCarouselOne
  },
  {
    tabText: "camTab.step2.tab",
    imgSrc: CameraPermissionTabImageTwo,
    carouselText: isUserAgentIOS()
      ? "camTab.step2.carousel_ios"
      : "camTab.step2.carousel_others",
    carouselImgSrc: isUserAgentIOS()
      ? CameraPermissionCarouselTwo
      : CamMicPermissionCarouselTwo
  },
  {
    tabText: "camTab.step3.tab",
    imgSrc: CameraPermissionTabImageThird,
    carouselText: isUserAgentIOS()
      ? "camTab.step3.carousel_ios"
      : "camTab.step3.carousel_ios",
    carouselImgSrc: isUserAgentIOS()
      ? CameraPermissionCarouselThree
      : AndroidCamPermissionCarouselThree
  }
]);

const camMicTabData = (t) => ([
  {
    tabText: "camMicTab.step1.tab",
    imgSrc: CamMicPermissionTabImageOne,
    carouselText: isUserAgentIOS()
      ? "camMicTab.step1.carousel_ios"
      : "camTab.step1.carousel_others",
    carouselImgSrc: isUserAgentIOS()
      ? CameraPermissionCarouselOne
      : CamMicPermissionCarouselOne
  },
  {
    tabText: "camMicTab.step2.tab",
    imgSrc: CamMicPermissionTabImageTwo,
    carouselText: isUserAgentIOS()
      ? "camMicTab.step2.carousel_ios"
      : "camMicTab.step2.carousel_others",
    carouselImgSrc: isUserAgentIOS()
      ? CameraPermissionCarouselTwo
      : CamMicPermissionCarouselTwo
  },
  {
    tabText: "camMicTab.step3.tab",
    imgSrc: CamMicPermissionTabImageThird,
    carouselText: isUserAgentIOS()
      ? "camMicTab.step3.carousel_ios"
      : "camMicTab.step3.carousel_others",
    carouselImgSrc: isUserAgentIOS()
      ? IOSCamMicPermissionCarouselThree
      : CamMicPermissionCarouselThree
  }
]);

const CarouselComponent = ({ type = "camera" }) => {
  const { t } = useTranslation()
  const tabData = type === "camera" ? cameraTabData(t) : camMicTabData(t)

  return (
    <Carousel>
      {
        tabData.map((tab, index) => {
          return (
            <CarouselItem>
              <div className={`tab flex flex-col items-center justify-center`}>
                <div className="tab-description flex items-center justify-center mb-20">
                  <div className="tab-number-carousel">
                    <span>{index + 1}</span>
                  </div>
                  <p className="tab-text-carousel">{t(`permissions.${tab.carouselText}`)}</p>
                </div>
                <div className="tab-image-carousel flex items-center justify-center">
                  <img src={tab.carouselImgSrc} alt="permission-access-microphone" />
                </div>
              </div>
            </CarouselItem>
          )
        })
      }
    </Carousel>
  );
};

const PermissionTabComponent = ({ tabText, tabNumber, imgSrc }) => {

  return (
    <div className={`tab pl-20 pr-20
      flex flex-col items-center justify-start
        ${tabNumber === 2 ? 'border' : ''}
      `}>
      <div className="tab-description flex items-center justify-center mb-20">
        <div className="tab-number">
          <span>{tabNumber}</span>
        </div>
        <p className="tab-text">{tabText}</p>
      </div>
      <div className="tab-image">
        <img src={imgSrc} alt="permission-access-microphone-1" />
      </div>
    </div>
  )
};

const PermissionsModal = ({
  visible = false,
  type = "",
  device = "camera",
  handleOnConfirm,
}) => {
  const isMobile = useIsMobileDevice()
  const { t } = useTranslation()

  const tabData = device === PERMISSION_DEVICE_TYPES.CAMERA
    ? cameraTabData(t)
    : device === PERMISSION_DEVICE_TYPES.CAMERA_MIC
      ? camMicTabData(t)
      : []
  const noCarouselType = [NO_INTERNET, VIDEO_SOURCE, NO_DEVICE, PERMISSION_DENIED_BY_SYSTEM, CAMERA_FEED, API_FAILURE, SCREEN_PERMISSION_DENIED, STOP_SHARING, ENTIRE_SCREEN, USER_GESTURE, API_BLOCK].includes(type)
  const modalWidth = isMobile ? "80%" : noCarouselType ? "50%" : "80%"

  const title = useMemo(() => {
    switch (type) {
      case NO_INTERNET: return t("permissions.no_internet.title")
      case CAMERA_FEED: return t("permissions.cam_feed.title")
      case VIDEO_SOURCE: return t("permissions.video_source.title")
      case NO_DEVICE: return t("permissions.no_device.title", { device: device[0]?.toUpperCase() + device?.slice(1,) })
      case PERMISSION_DENIED:
      case PERMISSION_DENIED_BY_SYSTEM: return t("permissions.permission_denied.title", { device })
      case SCREEN_PERMISSION_DENIED: return t("permissions.permission_denied.title", { device: "screen" })
      case STOP_SHARING: return t("permissions.sharing_stopped.title")
      case ENTIRE_SCREEN: return t("permissions.entire_screen.title")
      case USER_GESTURE: return t("permissions.screen_user_gesture.title")
      case API_FAILURE: return t("permissions.api_failure.title")
      case API_BLOCK: return ""
      default: return t("permissions.permission_general.title", { device })
    }
  }, [type, device])

  const subtext = useMemo(() => {
    switch (type) {
      case NO_INTERNET: return t("permissions.no_internet.subtext")
      case CAMERA_FEED: return t("permissions.cam_feed.subtext")
      case VIDEO_SOURCE: return t("permissions.video_source.subtext")
      case NO_DEVICE: return t("permissions.no_device.subtext", { device })
      case PERMISSION_DENIED: return t("permissions.permission_denied.subtext", { device })
      case PERMISSION_DENIED_BY_SYSTEM: return t("permissions.permission_denied_by_system.subtext", { device })
      case SCREEN_PERMISSION_DENIED: return t("permissions.permission_denied.subtext", { device: "screen" })
      case STOP_SHARING: return t("permissions.sharing_stopped.subtext")
      case ENTIRE_SCREEN: return t("permissions.entire_screen.subtext")
      case USER_GESTURE: return t("permissions.screen_user_gesture.subtext")
      case API_FAILURE: return t("permissions.api_failure.subtext", { device })
      case API_BLOCK: return t("permissions.api_block.subtext")
      default: return type
    }
  }, [type, device])

  return (
    <UnberryModal
      visible={visible}
      footer={false}
      className={"permission-modal"}
      width={modalWidth}
      closable={false}
      keyboard={false}
      maskStyle={{
        backdropFilter: "blur(4px)"
      }}
    >
      <div className={`permission-modal-body ${isMobile ? "mt-40" : ""} mb-40`}>
        <div className="description flex flex-col items-center justify-center mb-40">
          <h1 className={`${isMobile ? "heading-mobile size-28" : "size-40"}`}>
            {type === API_FAILURE && <span className="api-failure-warning-icon">&#9888;&#65039;</span>}
            {title}
          </h1>
          <p className={`${isMobile ? "heading-text size-14" : "size-16"}`}>
            {subtext}
          </p>
          {
            type === API_FAILURE && (
              <div className="api-failure-content">
                <p className={`api-failure-steps-heading ${isMobile ? "size-14" : "size-16"}`}>
                  {t("permissions.api_failure.steps_heading", "Please follow the steps below:")}
                </p>
                <ol className="api-failure-steps">
                  {(t("permissions.api_failure.steps", { returnObjects: true }) || []).map((step, index) => (
                    <li key={index} className={`${isMobile ? "size-14" : "size-16"}`}>{step}</li>
                  ))}
                </ol>
                <p className={`api-failure-footer ${isMobile ? "size-14" : "size-16"}`}>
                  {t("permissions.api_failure.steps_footer")}
                </p>
                <Button
                  type="primary"
                  className="size-16 br-25 width-200 mt-20"
                  onClick={() => window.location.reload()}
                >
                  <div className="color-alt">
                    {t("permissions.api_failure.refresh")}
                  </div>
                </Button>
              </div>
            )
          }
          {
            type !== API_FAILURE && handleOnConfirm ?
              <Button
                type="primary"
                className="size-16 br-25 width-200 mt-20"
                onClick={handleOnConfirm}
              >
                <div className="color-alt">
                  {t("webcam.continue")}
                </div>
              </Button>
              : <></>
          }
        </div>
        {
          !noCarouselType
            ? <div className="permission-tabs">
              {
                isMobile ? <CarouselComponent type={type} /> :
                  tabData.map((tab, index) => {
                    return (
                      <PermissionTabComponent
                        tabText={t(`permissions.${tab.tabText}`)}
                        tabNumber={index + 1}
                        imgSrc={tab.imgSrc}
                      />
                    )
                  })
              }
            </div> : <></>
        }
      </div >
    </UnberryModal >
  )
};

export default PermissionsModal;